import React from 'react';
import classname from 'classnames';
import styles from './Tertiary.module.scss';
import Button from '@/components/Button';

export default function Tertiary(props) {
	return <Button { ...props } className={ classname(styles.tertiary, props.className) }>{ props.children }</Button>;
}
